import { createFileRoute } from "@tanstack/react-router";
import { ContractBacktestPage } from "@/features/contracts/contract-backtest-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/prognoza-wsteczna")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.prognoza-wsteczna",
			location.pathname,
		);
	},
	component: ContractBacktestPage,
});
